// @flow
/** @jsx jsx */

import * as React from 'react';

import Text from '@zapier/common-components/src/components/Text';
import { Spacing } from '@zapier/theme';
import { css, jsx } from '@emotion/core';

type Props = {
  /** Children */
  children: React.Node | Array<React.Node>,
  /** Used to associate this label with a form field with a corresponding id */
  htmlFor?: string,
  /** The DOM id for this label */
  id?: string,
  /** `true` if it should render inline instead of as a block. Defaults to `false`. */
  isInline?: boolean,
  /** render with a span */
  isSpan?: boolean,
};

const defaultProps = {
  isInline: false,
};

const inlineCss = css({
  display: 'inline',
  marginBottom: 0,
});

const blockCss = css({
  display: 'block',
  marginBottom: Spacing.normal,
});

const FormLabel = (props: Props) => {
  const labelCss = props.isInline ? inlineCss : blockCss;

  const Tag = props.isSpan ? 'span' : 'label';

  return (
    <Tag css={labelCss} htmlFor={props.htmlFor} id={props.id}>
      <Text type="body-strong">{props.children}</Text>
    </Tag>
  );
};

FormLabel.defaultProps = defaultProps;

export default FormLabel;
